import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Box } from '@mui/system';
import { Button, Grid } from '@mui/material';

import useClasses from '../../../hooks/legacy/useClasses';

import notFoundImage from '../../../assets/images/notFound.png';
import notFoundLarge from '../../../assets/images/notFoundLarge.png';
import useSeo from '../../../hooks/useSeo';
import styles from './NotFound.style';

function NotFoundPage() {
  const classes = useClasses(styles);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/');
  };
  const { setPageTitle } = useSeo();

  useEffect(() => {
    setPageTitle('Not Found');
  }, []);

  return (
    <Box>
      <Grid container lg={12} xs={12} className={classes.flexDisplay}>
        <Grid lg={6} sm={6} className={classes.leftGrid}>
          <Box className={classes.parentBox}>
            <Box className={classes.subParent}>
              <Box className={classes.textColor}>404 error</Box>
              <Box className={classes.textFont}>Page not found</Box>
              <Box className={classes.sorryText}>
                Sorry, the page you are looking for doesn&apos;t exist.
              </Box>
              <Button
                data-test-id="goHome"
                className={classes.buttonBackground}
                onClick={handleNavigate}
              >
                Go back to home page
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid lg={6} sm={6} className={classes.flexDisplay}>
          <Box className={classes.imageOnLarge}>
            <img
              src={notFoundLarge}
              alt="notFound"
              className={classes.notFoundImgLarge}
            />
          </Box>
          <Box className={classes.imageOnSmall}>
            <img
              src={notFoundImage}
              alt="notFound"
              className={classes.notFoundImg}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default NotFoundPage;
